var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.247,
    height: 19.247,
    viewBox: "0 0 19.247 19.247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-settings",
    "data-name": "Icon feather-settings",
    transform: "translate(-0.75 -0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M18.34,15.92a2.42,2.42,0,1,1-2.42-2.42A2.42,2.42,0,0,1,18.34,15.92Z",
    transform: "translate(-5.547 -5.547)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M16.343,12.793a1.331,1.331,0,0,0,.266,1.468l.048.048a1.614,1.614,0,1,1-2.283,2.283l-.048-.048a1.342,1.342,0,0,0-2.275.952v.137a1.613,1.613,0,1,1-3.227,0v-.073a1.331,1.331,0,0,0-.871-1.218,1.331,1.331,0,0,0-1.468.266l-.048.048a1.614,1.614,0,1,1-2.283-2.283l.048-.048a1.342,1.342,0,0,0-.952-2.275H3.113a1.613,1.613,0,0,1,0-3.227h.073A1.331,1.331,0,0,0,4.4,7.953a1.331,1.331,0,0,0-.266-1.468l-.048-.048A1.614,1.614,0,1,1,6.372,4.154l.048.048a1.331,1.331,0,0,0,1.468.266h.065A1.331,1.331,0,0,0,8.76,3.25V3.113a1.613,1.613,0,1,1,3.227,0v.073a1.342,1.342,0,0,0,2.275.952l.048-.048a1.614,1.614,0,1,1,2.283,2.283l-.048.048a1.331,1.331,0,0,0-.266,1.468v.065A1.331,1.331,0,0,0,17.5,8.76h.137a1.613,1.613,0,1,1,0,3.227h-.073a1.331,1.331,0,0,0-1.218.807Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon-settings.4964b5be6b0fb682c3bd6a8e3e1c7fbf.svg";
export { ForwardRef as ReactComponent };